import { schema } from 'normalizr'

const restaurantMenuSection = new schema.Entity('restaurantMenuSections')

export default restaurantMenuSection
